import api from '@/api'

function hasProp(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop)
}

export default {
  list: (docType, documentId) =>
    new Promise((resolve, reject) => {
      api()
        .get(
          `/${docType.singular}management/${docType.singular}/${documentId}/versions`
        )
        .then(response => {
          const versions = response.data.data.version
          resolve(versions)
        })
        .catch(error => {
          if (error.response && hasProp(error.response.data.data, 'version')) {
            const versions = error.response.data.data.version
            resolve(versions)
          } else {
            reject(error.response.data)
          }
        })
    }),

  create: () => {
    //
  },

  read: (docType, documentId, versionId) =>
    new Promise((resolve, reject) => {
      const apiEndpoint = `/${docType.singular}management/${docType.singular}/${documentId}/version/${versionId}`

      api()
        .get(apiEndpoint)
        .then(response => {
          resolve(response.data.data.version[0])
        })
        .catch(error => {
          reject(error.response)
        })
    }),

  update: () => {
    //
  },

  delete: () => {
    //
  },

  // -------------------------------------

  approve: (docType, documentId, versionId) =>
    new Promise((resolve, reject) => {
      const apiEndpoint = `/${docType.singular}management/${docType.singular}/${documentId}/version/${versionId}/approve`

      api()
        .put(apiEndpoint)
        .then(response => {
          const version = response.data.data.version[0]
          resolve(version)
        })
        .catch(error => {
          if (error.response && hasProp(error.response.data.data, 'version')) {
            const version = error.response.data.data.version[0]
            resolve(version)
          } else {
            reject(error.response.data)
          }
        })
    }),

  reject: (docType, documentId, versionId, reason) =>
    new Promise((resolve, reject) => {
      const apiEndpoint = `/${docType.singular}management/${docType.singular}/${documentId}/version/${versionId}/reject`

      api()
        .put(apiEndpoint, {
          reject: {
            reason
          }
        })
        .then(response => {
          const version = response.data.data.version[0]
          resolve(version)
        })
        .catch(error => {
          if (error.response && hasProp(error.response.data.data, 'version')) {
            const version = error.response.data.data.version[0]
            resolve(version)
          } else {
            reject(error.response.data)
          }
        })
    })
}
